import { sentenceCase } from 'change-case';
import cs from 'classnames';
import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { BaseSummaryProps } from './types';


export const PaymentSummary = ({ application }: BaseSummaryProps) => {
  const steps = useRentalSteps({slug: slugs.payment});
  const payment = application?.payment;
  const errors = application?.validation?.payment;
  const isInvalid = !!errors;
  
  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>Payment Method - Credit Card</SummaryHeader>
      {!application ? <LoadingLabel alignment="left" /> : (
        <div className={cs(isInvalid && 'text-danger')}>
          {!payment ? <div>Card details not provided.</div> : (
            <>
              <div>Card ending in: {payment.maskedCardNumber}</div>
              <div>Expiry: {payment.expiryMM}/{payment.expiryYYYY}</div>
            </>
          )}
          {isInvalid && (
            <div className="small">
              {errors?.map(e => `${sentenceCase(e.field)}: ${e.messages.join(' ')}`)}
            </div>
          )}
        </div>
      )}
    </SummarySection>
  );
}
